import React from 'react';
import { useAuth } from '../context/AuthContext';

const NavIcon = ({ d }) => (
  <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
    <path d={d} />
  </svg>
);

const ICONS = {
  dashboard: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z',
  casos: 'M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13z',
  alertas: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z',
  nuevo: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z',
  usuarios: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
  colegios: 'M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82z',
};

export default function Sidebar({ active, onNavigate, pendientes, alertasCount, sidebarOpen, onClose, userRole }) {
  const { currentUser, logout } = useAuth();
  const initials = currentUser?.email?.slice(0, 2).toUpperCase() || 'U';

  const navItems = [
    { key: 'dashboard', label: 'Panel principal' },
    { key: 'casos', label: 'Casos', badge: pendientes > 0 ? pendientes : null },
    { key: 'alertas', label: 'Alertas', badge: alertasCount > 0 ? alertasCount : null },
    { key: 'nuevo', label: 'Nuevo caso' },
    ...(userRole === 'admin' ? [{ key: 'usuarios', label: 'Usuarios' }] : []),
    ...(userRole === 'admin' ? [{ key: 'colegios', label: 'Colegios' }] : []),
  ];

  return (
    <>
      <div className={`sidebar-overlay ${sidebarOpen ? 'open' : ''}`} onClick={onClose} />
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-stripe">
            <div className="logo-stripe-r" />
            <div className="logo-stripe-w" />
            <div className="logo-stripe-g" />
          </div>
          <div className="logo-title" style={{ color: '#fff' }}>GestorPrivadas</div>
          <div className="logo-sub" style={{ color: 'rgba(255,255,255,0.5)' }}>Distrito 1102 · Puerto Plata</div>
        </div>
        <nav className="sidebar-nav">
          {navItems.map(item => (
            <button
              key={item.key}
              className={`nav-link ${active === item.key ? 'active' : ''}`}
              onClick={() => { onNavigate(item.key); onClose(); }}
              style={{ color: active === item.key ? '#ffffff' : 'rgba(255,255,255,0.78)' }}
            >
              <NavIcon d={ICONS[item.key]} />
              {item.label}
              {item.badge && <span className="nav-badge">{item.badge}</span>}
            </button>
          ))}
        </nav>
        <div className="sidebar-user">
          <div className="user-avatar">{initials}</div>
          <div>
            <div className="user-name" style={{ color: '#fff' }}>{currentUser?.email?.split('@')[0]}</div>
            <div className="user-role" style={{ color: 'rgba(255,255,255,0.48)' }}>{userRole === 'admin' ? 'Administrador' : userRole === 'tecnico' ? 'Técnico' : 'Secretaria'}</div>
          </div>
          <button className="btn-logout" onClick={logout} title="Cerrar sesión">⏻</button>
        </div>
      </aside>
    </>
  );
}